<template>
  <v-footer class="footer">
    <div class="footer__content pa-3">
      <v-btn
        class="mb-2"
        :href="`https://www.facebook.com/buynow.bnpl`"
        target="_blank"
        text
        icon
        id="btn__link-to-facebook"
      >
        <v-icon>mdi-facebook</v-icon>
      </v-btn>
      <v-btn
        class="mb-2"
        :href="`https://www.instagram.com/buynow.kr.official/`"
        target="_blank"
        text
        icon
        id="btn__link-to-instagram"
      >
        <v-icon>mdi-instagram</v-icon>
      </v-btn>
      <v-btn
        class="mb-2"
        :href="`https://blog.naver.com/buynow_bnpl`"
        target="_blank"
        text
        icon
        id="btn__link-to-blog"
      >
        <img
          width="20px"
          height="20px"
          src="@/assets/images/icons/blog.png"
          class="check"
          alt="check"
        />
      </v-btn>
      <br />
      <template v-for="terms in termses">
        <span v-if="terms.type === 'terms_of_service'" :key="terms.uuid">
          <router-link
            id="btn__prwMajC0okCej8vTJM9XEQ=="
            style="text-decoration: none; color: #666666"
            :to="{ path: `/terms/${terms.uuid}` }"
            target="_blank"
            >{{ terms.title }}</router-link
          >
        </span>
      </template>
      &nbsp;&nbsp;
      <span>
        <router-link
          id="btn__9x5SxrpTwkiZm4RgPYdB7Q=="
          style="text-decoration: none; color: #666666"
          :to="{ path: `/terms/privacy` }"
          target="_blank"
          >개인정보 처리방침</router-link
        >
      </span>
      <br /><br />
      <p><strong>(주)온라인셀러혁신법인</strong></p>
      <p><strong>대표</strong> 이성현, 김태형</p>
      <p>서울 서초구 사평대로53길 30 메이크잇 204호</p>
      <p><strong>사업자등록번호</strong> 553-88-02500</p>
      <p>Copyright © OSI 2022. All Right Reserved.</p>
    </div>
  </v-footer>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('terms', ['termses']),
    ...mapGetters('contract', ['isServiceAvailable']),
  },
  created() {
    this.getTerms()
  },
  methods: {
    ...mapActions('terms', ['getTerms']),
  },
}
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: center;

  background-color: #f6f7f9 !important;

  padding: 16px 12px 0px;
}

.footer__content {
  // max-width: $standard-max-width;
  max-width: 500px;
  width: 100%;

  p {
    color: #666666;
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
}
</style>
